import type { Component } from './types';

import Image from 'next/image';

import { env } from '@/app/env';

export const SystemLogo: Component = () => {
  return (
    <>
      <Image
        alt="sgcarmart"
        className="mb-2"
        height={17}
        src={`${env.NEXT_PUBLIC_SGCM_IMAGE_MEDIA_URL}/ims/default/sgcm-logo.svg`}
        width={120}
      />
      <p className="text-xs font-medium italic">Inventory Management System</p>
    </>
  );
};
